import React, { useEffect, useState } from "react";
import { useLazyGetCourseProviderCommitteeApprovalListQuery } from "../../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import { Link, useParams } from "react-router-dom";
import { decryptAESID, encryptAESID } from "../../../utils/Encryption";
import DataLoader from '../../../components/ui/dataLoader/DataLoader';
import CenterModel from "../../../components/ui/centerModel/CenterModel";
import EditViewAccount from "../../Accountmanagement/ViewAccountManagement/EditViewAccount";
import MolGrid from "../../../components/Grid/MolGrid";
import EditCommitteApproval from "../component/EditCommitteApproval";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../../components/ui/image/Image";

const CommitteeApprovalTable = () => {
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const [getCommiteeApprovalList, { isSuccess: isgetCommiteeApprovalList, isLoading: isLoadinggetCommiteeApprovalList, data: getCommiteeApprovalListResponse },] = useLazyGetCourseProviderCommitteeApprovalListQuery();
  const [isModelOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState();
  useEffect(() => {
    getCommiteeApprovalList(editID)
  }, [editID])

  useEffect(() => {
    if (!isLoadinggetCommiteeApprovalList && isgetCommiteeApprovalList && getCommiteeApprovalListResponse) {
    }
  }, [isLoadinggetCommiteeApprovalList, isgetCommiteeApprovalList, getCommiteeApprovalListResponse]);

  const handleSave = (item) => {
    setSelectedId(item.adminId)
    setIsModalOpen(!isModelOpen)
  };
  const openCloseModal = () => {
    setIsModalOpen(!isModelOpen);
  };
  return (
    <div className="commitee-table">
      {isgetCommiteeApprovalList && getCommiteeApprovalListResponse ? (
        <div className="tableContainer">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Decision</th>
                <th>Decision Date</th>
                <th>Comments</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {getCommiteeApprovalListResponse.map((item, index) => (
                <tr key={index}>
                  <td>{item.adminName}</td>
                  <td>{item.decision}</td>
                  <td>
                    {item.approvalDate
                      ? new Date(item.approvalDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })
                      : ''}
                  </td>
                  <td>{item.comment}</td>
                  <td>
                    <Link
                      onClick={() => handleSave(item)}
                      className="mr-3"
                      title="Edit"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <DataLoader />
      )}
      <div className='row mt-4'>
        <div className='col-lg-12'>
          {isModelOpen && (
            <CenterModel
              modelTitle={'Committee Approval'}
              show={"test"}
              handleClose={openCloseModal}
              onUpload={openCloseModal}
            >
              <EditCommitteApproval selectedId={encryptAESID(selectedId)} isModelClose={openCloseModal} getCommiteeApprovalList={getCommiteeApprovalList} />
            </CenterModel>
          )}
        </div>
      </div>
    </div>
  );
};
export default CommitteeApprovalTable;
